import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import * as rotatingSlides from '@components/sections/features/components/rotating-slides/rotating-slides.js';

gsap.registerPlugin(ScrollTrigger);

const section = document.getElementById('machine-types');
const intro = section.querySelector('.machine-types__intro');
const introLine = section.querySelector('.machine-types__intro__line');
const slides = section.querySelector('.machine-types__rotating-slides');
const { goToSlide } = rotatingSlides.init(section.querySelector('.rotating-slides'));

const onEnter = () => {
  gsap.timeline()
    .to([intro, slides], {
      y: 0,
      autoAlpha: 1,
      duration: 1.0,
    })
    .to(introLine, {
      scaleY: 1.0,
      duration: 0.5,
    }, '-=0.5');
};
const onLeave = () => {
  gsap.to([intro, slides], {
    autoAlpha: 0,
    duration: 0.3,
  });
};

gsap.set(intro, { autoAlpha: 0, y: '+=100' });
gsap.set(slides, { autoAlpha: 0, y: '+=100' });
gsap.set(introLine, { scaleY: 0 });

// Pin section.
gsap.timeline({
  scrollTrigger: {
    pin: section,
    // end: '+=4000',
    end: '+=2000',
    scrub: true,
    fastScrollEnd: true,
    onUpdate(self) {
      const { progress } = self;

      if (progress >= 0.66) {
        // console.log('go to 2');
        goToSlide(2);
      } else if (progress >= 0.33) {
        // console.log('go to 1');
        goToSlide(1);
      } else if (progress >= 0) {
        // console.log('go to 0');
        goToSlide(0);
      }
    },
  },
});

// Animate section contents.
gsap.timeline({
  scrollTrigger: {
    trigger: section,
    start: 'top top',
    // end: '+=3500',
    end: '+=2500',
    scrub: true,
    fastScrollEnd: true,
    onEnter,
    onEnterBack: onEnter,
    onLeave,
    onLeaveBack: onLeave,
  },
});
